import React from "react";
import {RouteComponentProps, withRouter} from "react-router";
import DateTimePicker from "../../../common/components/shared/dateTimePicker/dateTimePicker";
import DropDown from "../../../common/components/shared/dropDown/dropDown";
import TextInput from "../../../common/components/shared/textInput/textInput";
import {DropDownModel} from "../../../common/models/dropDown";
import {FerryDropDownModel} from "../../../dictionaries/models/ferry";
import {FerryService} from "../../../dictionaries/services/ferryService";
import {DropDownUtils} from "../../../helpers/dropDownUtils";
import OrderStatusDropdownItems from "../../../helpers/orderStatusDropdownItems";
import RelationTypeDropdownItems from "../../../helpers/relationTypeDropdownItems";
import {ValidatedValue} from "../../../helpers/validatedValue";
import i18n from "../../../i18n/i18n";
import {OrderStatusEnum} from "../../models/order";
import {RelationType} from "../../models/relation";
import {AxiosResponse} from "axios";
import {HttpErrorModel} from "../../../common/models/httpError";
import {Api} from "../../../helpers/api";


interface TransportationFiltersProps extends RouteComponentProps {
    element: "ticket" | "order";
    selectedDateOfRegistrationFrom: ValidatedValue<Date | null>;
    selectedDateOfRegistrationTo: ValidatedValue<Date | null>;
    selectedArrivalDepartureTime: ValidatedValue<Date | null>;
    selectedFerry: ValidatedValue<string>;
    selectedOrderStatus: ValidatedValue<OrderStatusEnum | "">;
    selectedRelationType: ValidatedValue<RelationType| "">;
    searchInput: ValidatedValue<string>;
    onDateTimePickerChange: (newDate: Date | null, isDateFrom: boolean, isDateTo: boolean) => void;
    setIsLoading: (value: boolean) => void;
}

interface TransportationFiltersState {
    ferries: FerryDropDownModel[];
    ferriesResponse: AxiosResponse<HttpErrorModel[] | any> | undefined;
}
class TransportationFilters extends React.Component <TransportationFiltersProps,TransportationFiltersState> {
    constructor(props: any) {
        super(props);

        this.state = {
            ferries: [],
            ferriesResponse: undefined
        };
    }

    public async componentDidMount() {
        await this.getFerries();
        this.props.setIsLoading(this.state.ferries.length < 0);
    }

    public render () {
        const isTicket = this.props.element === "ticket";
        const searchListLabel = i18n.t(`transportation.filters.${isTicket ? "regNo" : "trailerNo"}`);

        return (
            <div className="filters">
                <DateTimePicker
                    label={i18n.t("transportation.filters.dateOfRegistrationFrom")}
                    validatedValue={this.props.selectedDateOfRegistrationFrom}
                    onChange={(newDate: Date | null) => {
                        if (this.props.onDateTimePickerChange) {
                            this.props.onDateTimePickerChange(newDate, true, false);
                        }
                    }}
                    testId="filters-date-of-registration-from"
                />
                <DateTimePicker
                    label={i18n.t("transportation.filters.dateOfRegistrationTo")}
                    validatedValue={this.props.selectedDateOfRegistrationTo}
                    onChange={(newDate: Date | null) => {
                        if (this.props.onDateTimePickerChange) {
                            this.props.onDateTimePickerChange(newDate, false, true);
                        }
                    }}
                    testId="filters-date-of-registration-to"
                />
                <DateTimePicker
                    label={i18n.t("transportation.filters.arrivalDepartureTime")}
                    validatedValue={this.props.selectedArrivalDepartureTime}
                    onChange={(newDate: Date | null) => {
                        if (this.props.onDateTimePickerChange) {
                            this.props.onDateTimePickerChange(newDate, false, false);
                        }
                    }}
                    testId="filters-arrival-departure-time"
                />
                <DropDown
                    label={i18n.t("transportation.filters.orderStatus")}
                    items={OrderStatusDropdownItems.getOrderStatusDropdownItems()}
                    validatedValue={this.props.selectedOrderStatus}
                    testId="filters-order-status"
                    withEmptyValue
                />
                {!isTicket && (<DropDown
                    label={i18n.t("transportation.filters.relationType")}
                    items={RelationTypeDropdownItems.getRelationTypesWithoutTicket()}
                    validatedValue={this.props.selectedRelationType}
                    testId="filters-relation-type"
                    withEmptyValue
                    withoutSort
                />)}
                <DropDown
                    label={i18n.t("transportation.filters.ferry")}
                    items={this.ferryToDropDownMap}
                    validatedValue={this.props.selectedFerry}
                    testId="filters-ferry"
                    withEmptyValue
                    error={!Api.isSuccess(this.state.ferriesResponse) ? i18n.t("errorMessages.ferriesErrorSuffix") : ""}
                    reloadFunc={() => this.getFerries()}
                    isNoRequired
                />
                <TextInput
                    label={searchListLabel}
                    testId="search-input"
                    validatedValue={this.props.searchInput}
                />
            </div>
        );
    }

    private get ferryToDropDownMap(): DropDownModel[] {
        return DropDownUtils.listToDropDownMap(this.state.ferries, "entityId");
    }

    private async getFerries() {
        const ferriesResponse = await FerryService.getFerriesForDropDown();

        this.setState({
            ferries: (ferriesResponse)?.data || [],
            ferriesResponse,
        });
    }
}

export default withRouter(TransportationFilters);
